import {
  GET_OFFERS,
  GET_OFFER,
  ADD_OFFER,
  UPDATE_OFFER,
  DELETE_OFFER,
  OFFER_ERROR,
  OFFER_LOADING,
} from "./types";

const BASE_URL_PROVIDERS = process.env.REACT_APP_API_URL;

const getToken = () => {
  const uid = localStorage.getItem("uid");
  return uid ? JSON.parse(uid).token : "";
};

// ✅ Get All Offers by Provider
export const getOffers = (providerId) => async (dispatch) => {
  dispatch({ type: OFFER_LOADING });
  try {
    console.log(`${BASE_URL_PROVIDERS}/offers/getOffersByProviderId/${providerId}`);
    
    const res = await fetch(
      `${BASE_URL_PROVIDERS}/offers/getOffersByProviderId/${providerId}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    const data = await res.json();
    console.log(data);
    
    dispatch({ type: GET_OFFERS, payload: data || [] });
  } catch (err) {
    dispatch({ type: OFFER_ERROR, payload: err.message });
  }
};

// ✅ Get Single Offer
export const getOffer = (offerId) => async (dispatch) => {
  dispatch({ type: OFFER_LOADING });
  try {
    const res = await fetch(
      `${BASE_URL_PROVIDERS}/offers/${offerId}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    const data = await res.json();
    dispatch({ type: GET_OFFER, payload: data.result });
  } catch (err) {
    dispatch({ type: OFFER_ERROR, payload: err.message });
  }
};

// ✅ Add Offer
export const addOffer = (payload) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_URL_PROVIDERS}/offers`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    dispatch({ type: ADD_OFFER, payload: data.data });
    //dispatch(getOffers(payload.provider)); // refresh list
  } catch (err) {
    dispatch({ type: OFFER_ERROR, payload: err.message });
  }
};

// ✅ Update Offer
export const updateOffer = ({ payload }) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_URL_PROVIDERS}/offers/${payload._id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    dispatch({ type: UPDATE_OFFER, payload: data.result });
    //dispatch(getOffers(payload.providerId));
  } catch (err) {
    dispatch({ type: OFFER_ERROR, payload: err.message });
  }
};

// ✅ Delete Offer
export const deleteOffer = ({ offerId, providerId }) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_URL_PROVIDERS}/offers/${offerId}`,
      {
        method: "DELETE",
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );
    await res.json();
    dispatch({ type: DELETE_OFFER, payload: offerId });
    dispatch(getOffers(providerId));
  } catch (err) {
    dispatch({ type: OFFER_ERROR, payload: err.message });
  }
};
